export const INFO_LINKS = {
  HOME: 'https://aulainfo.dk/',
  PRIMARY_INSTITUTION:
    'https://aulainfo.dk/hjaelp-og-vejledninger/min-profil-og-kontaktoplysninger#83ef48af-7d87-42b8-83f5-cdab2152e2b0',
  SHARED_CONTACT_INFORMATION_PERSONAL:
    'https://aulainfo.dk/hjaelp-og-vejledninger/min-profil-og-kontaktoplysninger#4eb7dbe4-af41-45bf-a5dc-f5913557ba0c',
  SHARED_CONTACT_INFORMATION_CHILD:
    'https://aulainfo.dk/hjaelp-og-vejledninger/min-profil-og-kontaktoplysninger#6a26fc9c-92a1-4c67-9e5d-7836cb9e4426',
  ADD_BCC: 'https://aulainfo.dk/hjaelp-og-vejledninger/beskeder#dd651117-6bd0-4c04-b7a4-319f0574d670',
  MARK_AS_SENSITIVE: 'https://aulainfo.dk/hjaelp-og-vejledninger/beskeder#b209bb49-946a-4e5b-a008-4774e4bbcbe0',
  ROOM: 'https://aulainfo.dk/hjaelp-og-vejledninger/kalender#926101eb-6885-42a7-834e-bfbab824d9b2',
  SEND_EVENT_REMINDER: 'https://aulainfo.dk/hjaelp-og-vejledninger/kalender#926101eb-6885-42a7-834e-bfbab824d9b2',
  CALENDAR_ATTACH_FILE: 'https://aulainfo.dk/hjaelp-og-vejledninger/kalender#bbf42904-6933-4dae-bbb4-7a0b4b15f4fe',
  SEND_NOTIFICATION: 'https://aulainfo.dk/hjaelp-og-vejledninger/kalender#11ebcc48-938e-4f76-b745-8777c556813e',
  RESOURCE: 'https://aulainfo.dk/hjaelp-og-vejledninger/kalender#68c68048-d9fd-4fe3-9729-d000efc53046',
  MULTIPLE_PEOPLE_SAME_SLOT: 'https://aulainfo.dk/hjaelp-og-vejledninger/kalender#bbf42904-6933-4dae-bbb4-7a0b4b15f4fe',
  ATTACH_FILE: 'https://aulainfo.dk/hjaelp-og-vejledninger/kalender#bbf42904-6933-4dae-bbb4-7a0b4b15f4fe',
  LESSON_NOTE_TO_CLASS: 'https://aulainfo.dk/hjaelp-og-vejledninger/kalender#11be7bb7-de17-47df-ac23-5836996cd960',
  LESSON_NOTE_TO_TEACHER: 'https://aulainfo.dk/hjaelp-og-vejledninger/kalender#11be7bb7-de17-47df-ac23-5836996cd960',
  DOCUMENT_CONCERNS: 'https://aulainfo.dk/hjaelp-og-vejledninger/sikre-filer#5575d640-26b3-4c33-b2ff-663486f4ecab',
  DOCUMENT_SHARED_WITH: 'https://aulainfo.dk/hjaelp-og-vejledninger/sikre-filer#fe3c2f4f-80f9-4638-bf8d-6950efc6b357',
  VIDEO_CONVERSION_FAILED: 'https://aulainfo.dk/hjaelp-og-vejledninger/galleri#74bd2348-0649-419e-8825-44bfbd83c3e8',
} as const;

export type InfoArea = keyof typeof INFO_LINKS;
